import { makeVar } from "@apollo/client"

const makeHubFiltersVar = () => ({
  groups: [],
  locations: [],
  tags: [],
  hasAssetAttached: null
})

const hubFiltersVar = makeVar({
  ...makeHubFiltersVar()
})

const resetHubFiltersVar = () => {
  hubFiltersVar({ ...makeHubFiltersVar() })
}

export { resetHubFiltersVar, hubFiltersVar }
